<div class="w-full bg-white p-5 border-round shadow-1">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

  <div class="flex justify-content-between align-items-center mb-4">
    <h2 class="m-0 font-bold text-900">Gestión de Colores</h2>
    <button pButton label="Nuevo Color" icon="pi pi-plus" class="p-button-black" (click)="openNew()"></button>
  </div>

  <p-table [value]="colors" [rows]="10" [paginator]="true" responsiveLayout="scroll" [rowHover]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>Nombre</th>
        <th>Muestra</th>
        <th>Código Hex</th>
        <th class="text-center">Estado</th>
        <th class="text-center">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-c>
      <tr>
        <td class="font-bold">{{ c.name }}</td>
        <td>
          <div class="w-2rem h-2rem border-circle border-1 border-300 shadow-1" 
               [style.background-color]="c.hexCode"></div>
        </td>
        <td class="font-mono text-600">{{ c.hexCode }}</td>
        <td class="text-center">
          <i class="pi" [ngClass]="c.isActive ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'" style="font-size: 1.2rem;"></i>
        </td>
        <td class="text-center">
          <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-warning" (click)="editColor(c)"></button>
          <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="c.isActive ? 'text-red-500' : 'text-green-500'" (click)="toggleColor(c)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="colorDialog" header="Detalle Color" [modal]="true" [style]="{width: '400px'}" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <div class="field">
      <label class="font-bold">Nombre del Color</label>
      <input pInputText [(ngModel)]="color.name" required autofocus placeholder="Ej: Rojo Pasión" />
      <small class="p-error" *ngIf="submitted && !color.name">Nombre requerido.</small>
    </div>
    
    <div class="field">
      <label class="font-bold">Seleccionar Color</label>
      <div class="flex align-items-center gap-3">
          <input type="color" [(ngModel)]="color.hexCode" class="h-3rem w-full cursor-pointer border-1 border-300" style="padding: 0;">
          <input pInputText [(ngModel)]="color.hexCode" class="w-8rem text-center font-mono" />
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="colorDialog = false"></button>
    <button pButton label="Guardar" icon="pi pi-check" class="p-button-black" (click)="saveColor()"></button>
  </ng-template>
</p-dialog>